import React, { useState, useEffect} from 'react';
import { Container, Alert}  from '@mui/material';


import Autocomplete from 'react-autocomplete';
import { useNavigate } from 'react-router-dom';

import * as Config from '../Config.js'; 

import TopAppBar from './TopAppBar' ;
import { useTranslation } from "react-i18next";


const AskFriendScreen = (props) => {    
    const {t} = useTranslation() ;
    const navigate = useNavigate();
     
    const [candidates, setCandidates] = useState([]) ;
    const [value, setValue] = useState('') ;
    const [ok, setOk] = useState(false) ;
    const [warn, setWarn] = useState(false) ;
    
    
    
    const listCandidates = () => {
        console.log('listCandidates invoked') ;
        fetch(Config.apiUrl  + '/site/friendcandidates',  {
            credentials: 'include',
        })
        .then(response => response.json())
        .then( (res) => {
            if (res.success) {
                console.log('listCandidates') ;
                console.log(res.data) ;
                setCandidates(res.data) ;
            } else {
                navigate('/') ;
            }
        })
    }      
    
    useEffect(() => { 
        console.log('useeffect invoked') ;
        listCandidates() ;
    // the next line prevents the useEffect excessive warning
    // eslint-disable-next-line react-hooks/exhaustive-deps    
    },[]) 
    
        
    const ask = (name) => {
        setOk(false);
        setWarn(false) ;
        console.log(name) ;
        // get id_friend
        let cand = candidates.find((elem) => {return elem.name === name}) ;
        
        const data = new FormData();
        data.append('id_friend', cand.id);

        fetch(Config.apiUrl  + '/site/askforfriend',  {
            method: 'POST',
            credentials: 'include',
            body: data,
        })
        .then(response => response.json())
        .then( (res) => {
            if (res.success) {
                setOk(true) ;
            } else {
                if (res.error === 'access forbidden') {
                    navigate('/') ;
                } else {
                    setWarn(true) ;
                }
            }
        })
    } 
    
    
    return (
         <Container maxWidth="sm" >
            <TopAppBar 
                title={t("Make a friend request")} 
                returnLink={"/my_friends"}
            />
            {ok && 
            <Alert severity="success">{t("Friend request has been sent") + ' ' +  t('to') + ' ' + value }</Alert>
            }         
            {warn && 
                <Alert severity="warning">{t("This request has been done already")}</Alert>
            }     
            <h4>Rechercher</h4>
            
            <Autocomplete
                getItemValue={(item) => item.name}
                items={candidates}
                renderItem={(item, isHighlighted) =>
                  <div style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                    {item.name}
                  </div>
                }
                value={value}
                onChange={(e) => setValue(e.target.value)}
                onSelect={(val) => {setValue(val) ; ask(val)}}
            />
            
        </Container>    
    ) ;
}

export default AskFriendScreen ;
